import m1 from "@/assets/avatars/progression/stage-1.jpg";
import m2 from "@/assets/avatars/progression/stage-2.jpg";
import m3 from "@/assets/avatars/progression/stage-3.jpg";
import m4 from "@/assets/avatars/progression/stage-4.jpg";
import m5 from "@/assets/avatars/progression/stage-5.jpg";
import m6 from "@/assets/avatars/progression/stage-6.jpg";
import m7 from "@/assets/avatars/progression/stage-7.jpg";
import m8 from "@/assets/avatars/progression/stage-8.jpg";
import f1 from "@/assets/avatars/female/stage-1-encumbered.png";
import f2 from "@/assets/avatars/female/stage-2-resolved.png";
import f3 from "@/assets/avatars/female/stage-3-reformed.png";
import f4 from "@/assets/avatars/female/stage-4-cohortian.png";
import f5 from "@/assets/avatars/female/stage-5-tempered.png";
import f6 from "@/assets/avatars/female/stage-6-watchwoman.png";
import f7 from "@/assets/avatars/female/stage-7-vanguard.png";
import f8 from "@/assets/avatars/female/stage-8-virtuous-woman.png";

export const MALE_STAGE_ART = [m1, m2, m3, m4, m5, m6, m7, m8];
export const FEMALE_STAGE_ART = [f1, f2, f3, f4, f5, f6, f7, f8];

/** Absolute URL of the built-in stage picture, used as the pose/scene reference for AI avatars. */
export function stageArtUrl(gender: string | undefined, stage: number): string | undefined {
  if (stage < 1 || stage > 8) return undefined;
  const src = (gender === "female" ? FEMALE_STAGE_ART : MALE_STAGE_ART)[stage - 1];
  return new URL(src, window.location.origin).toString();
}
